import {
  ADD_CATEGORIES_TO_COMPANY_DIR_VENDOR,
  ADD_TAGS_TO_COMPANY_DIR_VENDOR,
  ADD_VENDORS_TO_CD_FROM_N2,
  DELETE_COMPANY_DIR_VENDOR,
  FILTER_COMPANY_DIR,
  REMOVE_TAGS_TO_COMPANY_DIR_VENDOR,
  SEARCH_COMPANY_DIR_VENDOR,
} from "config/services";
import axios from "utils/axios";

const normalizeOrderValueRange = (value = {}) => {
  if (!value || typeof value !== "object") return null;

  const min = Number(value.min);
  const max = Number(value.max);

  return {
    min: Number.isFinite(min) ? min : null,
    max: Number.isFinite(max) ? max : null,
  };
};

class CompanyDirectoryService {
  searchVendor = (searchParam, pageNum, entityId, userId) =>
    new Promise((resolve, reject) => {
      const page = pageNum || 1;
      axios
        .get(
          `${SEARCH_COMPANY_DIR_VENDOR}?entityId=${entityId}&searchParam=${searchParam}&page=${page}&userId=${userId}`
        )
        .then((response) => {
          if (response?.data?.error) {
            reject(response.data.message);
          } else {
            resolve(response?.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  addVendorsFromNeevayNetworkWithTags = (payload) =>
    new Promise((resolve, reject) => {
      axios
        .post(ADD_VENDORS_TO_CD_FROM_N2, payload)
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  buildFilterParams = ({ entityId, page, filterData = {} }) => {
    const params = new URLSearchParams({
      entityId,
      page,
    });

    if (filterData?.location) {
      params.append("location", filterData.location);
    }

    const areaFilters = Array.isArray(filterData?.area)
      ? filterData.area
      : filterData?.area
        ? [filterData.area]
        : [];

    areaFilters.forEach((area) => {
      params.append("area", area);
    });

    const orderValueRange = normalizeOrderValueRange(filterData?.totalOrderValue);
    if (orderValueRange?.min !== null) {
      params.append("minOrderValue", orderValueRange.min);
    }
    if (orderValueRange?.max !== null) {
      params.append("maxOrderValue", orderValueRange.max);
    }

    return params;
  };

  postFilterVendor = ({ page, filterData = {}, searchKey = "", userId, entityId }) => {
    const params = this.buildFilterParams({ entityId, page, filterData });
    const requestFilters = { ...filterData };
    delete requestFilters.totalOrderValue;

    return axios
      .post(`${FILTER_COMPANY_DIR}?${params.toString()}`, {
        filters: requestFilters,
        searchParam: searchKey,
        userId,
      })
      .then((response) => response?.data);
  };

  filterVendor = async ({
    pageNum = 1,
    filterData = {},
    searchKey = "",
    userId,
    entityId,
  }) => {
    const page = pageNum || 1;
    return this.postFilterVendor({
      page,
      filterData,
      searchKey,
      userId,
      entityId,
    });
  };

  addTags = (payload) =>
    new Promise((resolve, reject) => {
      axios
        .patch(ADD_TAGS_TO_COMPANY_DIR_VENDOR, payload)
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  removeTags = (payload) =>
    new Promise((resolve, reject) => {
      axios
        .post(REMOVE_TAGS_TO_COMPANY_DIR_VENDOR, payload)
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  addCategories = (payload) =>
    new Promise((resolve, reject) => {
      axios
        .patch(ADD_CATEGORIES_TO_COMPANY_DIR_VENDOR, payload)
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteVendor = ({ vendorId, entityId, userId, userName }) =>
    new Promise((resolve, reject) => {
      axios
        .delete(DELETE_COMPANY_DIR_VENDOR, {
          params: {
            vendorId,
            entityId,
            userId,
            userName,
          },
        })
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const companyDirectoryService = new CompanyDirectoryService();
export default companyDirectoryService;
